// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class AssertionError extends Error {
    /**
     * Assert a certain condition.
     *
     * @param condition The condition to assert.
     * @param msg A message, or function to retrieve one, for when the assertion fails.
     * @throws AssertionError When the `condition` is false.
     */
    static assert(condition, msg) {
        if (!condition) {
            throw new AssertionError(typeof msg === 'function' ? msg() : msg);
        }
    }
    /** @inheritdoc */
    static assertInstance(cls, obj) {
        if (obj == null) {
            return (innerObj) => AssertionError.assertInstance(cls, innerObj);
        }
        if (obj instanceof cls) {
            return obj;
        }
        const objTyp = obj?.constructor?.name ?? typeof obj;
        throw new AssertionError(`Expected a value of type "${cls.name}" but got a "${objTyp}"`);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static assertNever(value, msg) {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        throw new AssertionError(msg ?? `The value ${value} was never expected to exist`);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static typeAssert(_) {
        // NOT EMPTY
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static typeEqual(_) {
        // NOT EMPTY
    }
}
